import { DecimalPipe } from '@angular/common'
import { HttpParams } from '@angular/common/http'
import { Component, effect, input, signal } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { WjChartModule } from '@grapecity/wijmo.angular2.chart'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { BaseComponent, ColumnChart, ListItem } from '../../../shared'
import { AutoSizeDirective } from '../../../shared/utility/auto-size.directive'

@Component({
    selector: 'app-department-chart',
    templateUrl: './department-chart.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, WjChartModule, AutoSizeDirective, DecimalPipe],
})
export class DepartmentChartComponent extends BaseComponent {
    faSpinner = faSpinner
    active = input(1)

    departments = input<ListItem<string>[]>([])
    selectedDept = signal('20')

    chartData!: ColumnChart
    unallocatedHours = 0

    constructor() {
        super()
        effect(() => {
            if (this.active() === 3) this.refresh()
        })
    }

    refresh() {
        if (this.active() !== 3) return
        const params = new HttpParams().set('deptCode', this.selectedDept())
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.get('/api/ProjectedHours/GetDepartmentChart', params)).subscribe({
                next: result => {
                    console.log('result', result)
                    this.chartData = result[0].chart
                    this.unallocatedHours = result[0].unallocatedHours
                },
            }),
        )
    }
}

export enum ProjectedHoursChartSeriesType {
    Total,
    Job,
    JobType,
    Phase,
    PrDept,
}
